import { InputProps } from '../types'
import NumberInputBase from './NumberInputBase'

interface NumberInputProps extends InputProps {
  min?: number
  max?: number
  step?: number
}

/**
 * Renders a number input field with a label
 * has increment and decrement buttons to adjust the input value
 * @returns {JSX.Element} The rendered input component.
 */
export default function NumberInput({
  onChange,
  invalid,
  errorMessage,
  question,
  min = -Infinity,
  max = Infinity,
  step = 1,
}: NumberInputProps) {
  return (
    <NumberInputBase
      id={`question-${question.id}`}
      label={question.text}
      value={(question.value as string) ?? ''}
      onChange={onChange}
      min={min}
      max={max}
      step={step}
      required={question.required}
      invalid={!!invalid}
      errorMessage={errorMessage}
    />
  )
}
